import React from 'react';

import FavoriteEmptyIcon from '@mui/icons-material/FavoriteBorder';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';

const AddReactionActionButton = (props: IBaseActionButtonProps) => {
  return (
    <BaseActionButton {...props}>
      <FavoriteEmptyIcon />
    </BaseActionButton>
  );
};

export default AddReactionActionButton;
